import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ReduxState } from "../../../../../redux";
import { setOption } from "../../../../../redux/reducers/DownloadOptions";
import { useLocalStorage } from "../../../../../utils/prefs";
import {
  loadExportDateFormatServer,
  saveContractdPreferenceServer,
} from "../../../../../docuclipper/api";

const options = [
  {
    value: "DD/MM/YYYY",
    label: "DD/MM/YYYY",
  },
  {
    value: "MM/DD/YYYY",
    label: "MM/DD/YYYY",
  },
  {
    value: "YYYY-MM-DD",
    label: "YYYY-MM-DD",
  },
];

const ALLOWED_FORMATS = options.map((o) => o.value);

export const DateFormatOptions: React.FC = () => {
  const dispatch = useDispatch();

  const { options: reduxOptions } = useSelector(
    (state: ReduxState) => state.DownloadOptions
  );

  const [selectedOptionLS, setSelectedOptionLS] = useLocalStorage(
    `docuclipper.prefs.dateFormat`,
    ""
  );

  React.useEffect(() => {
    let cancelled = false;
    // Seed from the backend-resolved export date format on every mount so the
    // dropdown reflects the contract-level preference (shared across all users
    // in the contract), falling back to the user's per-user/country default and
    // finally the redux default. The server value wins so teammates stay in sync.
    (async () => {
      let serverFormat = "";
      try {
        const value = await loadExportDateFormatServer();
        if (value && ALLOWED_FORMATS.includes(value)) {
          serverFormat = value;
        }
      } catch (err) {
        // Ignore. Fall back to redux default.
      }
      if (cancelled) return;
      const next =
        serverFormat ||
        reduxOptions[`docuclipper.prefs.dateFormat`] ||
        "YYYY-MM-DD";
      setSelectedOptionLS(next);
      dispatch(
        setOption({
          key: `docuclipper.prefs.dateFormat`,
          value: next,
        })
      );
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  React.useEffect(() => {
    dispatch(
      setOption({
        key: `docuclipper.prefs.dateFormat`,
        value: selectedOptionLS || "YYYY-MM-DD",
      })
    );
  }, [selectedOptionLS]);

  const value = reduxOptions[`docuclipper.prefs.dateFormat`];

  return (
    <Select
      options={options}
      value={{ value, label: value }}
      onChange={(value) => {
        const v = value ? value.value || "" : "";
        setSelectedOptionLS(v);
        dispatch(
          setOption({
            key: `docuclipper.prefs.dateFormat`,
            value: v,
          })
        );
        // Persist contract-wide so all users in the contract inherit this as
        // their default export date format (export display only — does not
        // affect extraction date parsing).
        if (v && ALLOWED_FORMATS.includes(v)) {
          saveContractdPreferenceServer({ key: "dateFormat", value: v }).catch(
            () => {
              // Non-fatal: the chosen format still applies to this download.
            }
          );
        }
      }}
    />
  );
};
export default DateFormatOptions;
